import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
// import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from 'environments/environment';
@Injectable()
export class AuthService {
    constructor(public router:Router,
        // public afAuth: AngularFireAuth,
        public location:Location) {
    }
    isAuthenticated(){
        if(localStorage.getItem('token')){
            return true;
        }
        return false;
    }
   
}